// extracted by mini-css-extract-plugin
export default {"section":"Login_section__hwqlZ","notice":"Login_notice__TVIbt","button":"Login_button__boHdf","terms":"Login_terms__hIVFl"};